'use client';
import React, { createContext, useCallback, useEffect, useState } from 'react';
import { getConnectionPayload, getConnectionStatus, onConnectObservable } from '../../services/bridge-service';
import getUserInfo from '../getUserInfo';
var defaultValue = {
    user: undefined,
    ready: false
};
export var AuthContext = createContext(defaultValue);
var AuthProvider = function (_a) {
    var children = _a.children;
    var _b = useState(), user = _b[0], setUser = _b[1];
    var _c = useState(false), ready = _c[0], setReady = _c[1];
    var fetchUserInfo = useCallback(function () {
        getUserInfo()
            .then(function (userInfo) {
            if (!userInfo.error) {
                setUser(userInfo);
            }
            setReady(true);
        })["catch"](function () {
            setReady(true);
        });
    }, []);
    // Set the initial user info
    var setPreUserInfo = useCallback(function () {
        var preUserInfo = getConnectionPayload().userInfo;
        if (preUserInfo === null || preUserInfo === void 0 ? void 0 : preUserInfo.accountId) {
            setUser(preUserInfo);
        }
    }, []);
    // Fetch user info
    useEffect(function () {
        if (getConnectionStatus() === 'connected') {
            setPreUserInfo();
        }
        var onConnectHandler = function () {
            setPreUserInfo();
            onConnectObservable.unsubscribe(onConnectHandler);
            fetchUserInfo();
        };
        fetchUserInfo();
        onConnectObservable.subscribe(onConnectHandler);
        return function () {
            onConnectObservable.unsubscribe(onConnectHandler);
        };
    }, [fetchUserInfo, setPreUserInfo]);
    return React.createElement(AuthContext.Provider, { value: { user: user, ready: ready } }, children);
};
export default AuthProvider;
